<h2 class="form-title">Additional Predicates</h2>
<div [formGroup]="predicatesForm" class="form-grid-secondary">
  <nz-form-item>
    <nz-form-label>Age Level</nz-form-label>
    <nz-form-control [nzErrorTip]="getError('ageLevel')">
      <nz-select
        formControlName="ageLevel"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzMode="multiple"
        nzShowArrow="true"
        nzPlaceHolder="Select age level"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('ageLevel') ? 'error' : ''">
        <nz-option
          *ngFor="let age of ageLevels; trackBy: trackByFn"
          [nzLabel]="age.name"
          [nzValue]="age.id">
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>Environment</nz-form-label>
    <nz-form-control [nzErrorTip]="getError('environment')">
      <nz-select
        formControlName="environment"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzMode="multiple"
        nzShowArrow="true"
        nzPlaceHolder="Select environment"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('environment') ? 'error' : ''">
        <nz-option
          *ngFor="let env of environments; trackBy: trackByFn"
          [nzLabel]="env.name"
          [nzValue]="env.id">
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>Functions</nz-form-label>
    <nz-form-control [nzErrorTip]="getError('functions')">
      <nz-select
        formControlName="functions"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzMode="multiple"
        nzShowArrow="true"
        nzPlaceHolder="Select functions"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('functions') ? 'error' : ''">
        <nz-option
          *ngFor="let item of functions; trackBy: trackByFn"
          [nzLabel]="item.name"
          [nzValue]="item.id">
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>Setting Events</nz-form-label>
    <nz-form-control [nzErrorTip]="getError('settingEvents')">
      <nz-select
        formControlName="settingEvents"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzMode="multiple"
        nzShowArrow="true"
        nzPlaceHolder="Select setting events"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('settingEvents') ? 'error' : ''">
        <nz-option
          *ngFor="let item of settingEvents; trackBy: trackByFn"
          [nzLabel]="item.name"
          [nzValue]="item.id">
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>Antecedents</nz-form-label>
    <nz-form-control [nzErrorTip]="getError('antecedents')">
      <nz-select
        formControlName="antecedents"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzMode="multiple"
        nzShowArrow="true"
        nzPlaceHolder="Select antecedents"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('antecedents') ? 'error' : ''">
        <nz-option
          *ngFor="let item of antecedents; trackBy: trackByFn"
          [nzLabel]="item.name"
          [nzValue]="item.id">
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label>Consequences </nz-form-label>
    <nz-form-control [nzErrorTip]="getError('consequences')">
      <nz-select
        formControlName="consequences"
        nzSuffixIcon
        nzShowSearch
        nzAllowClear
        nzMode="multiple"
        nzShowArrow="true"
        nzPlaceHolder="Select consequences"
        [nzOptionOverflowSize]="7"
        [nzStatus]="isInvalid('consequences') ? 'error' : ''">
        <nz-option
          *ngFor="let item of behaviourConsequence; trackBy: trackByFn"
          [nzLabel]="item.name"
          [nzValue]="item.id">
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>
</div>
